interface CaseItem {
  id: string;
  title: string;
  description: string;
  category: string;
  stat: string;
}

interface CasesProps {
  cases: CaseItem[];
}

export default function Cases({ cases }: CasesProps) {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 font-heading mb-4">
            成功案例
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            5000+企业客户的信赖之选，用实力赢得口碑
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {cases.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/70 flex flex-col"
            >
              <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4 w-fit">
                {item.category}
              </span>
              <h3 className="text-lg font-bold text-foreground-900 mb-3 font-heading">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4 flex-1">
                {item.description}
              </p>
              <div className="pt-4 border-t border-background-200">
                <span className="text-sm font-semibold text-primary-600">{item.stat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}